import _ from 'underscore'
import { DateTime } from '../../../domain/DateTime'
import { TracepointRule } from '../../../domain/TracepointRule'
import { FULFILLED } from '../action-helper'
import {
    ADD_TRACE_BOOST,
    FETCH_ACTIVE_TRACE_BOOSTS,
    FETCH_TRACE_BOOST,
    FETCH_TRACE_BOOSTS,
    TERMINATE_TRACE_BOOST,
    UPDATE_TRACE_BOOST,
} from './actions'
import { TracepointRuleState } from './TracepointRuleState'

const initialState: TracepointRuleState = {
    byId: {},
    byTransactionId: {},
    loaded: false,
}

export const tracepointRuleReducer = (state: any = initialState, action: any) => {
    let byTransactionId = {}
    let byId = {}

    switch (action.type) {
        case FULFILLED(ADD_TRACE_BOOST):
        case FULFILLED(UPDATE_TRACE_BOOST):
        case FULFILLED(TERMINATE_TRACE_BOOST):
            byTransactionId = { ...state.byTransactionId }
            byId = { ...state.byId }

            addRule(action.payload, byId, byTransactionId)

            break
        case FULFILLED(FETCH_TRACE_BOOST):
            addRule(action.payload, byId, byTransactionId)
            break
        case FULFILLED(FETCH_TRACE_BOOSTS):
            action.payload.forEach(rule => {
                // @todo add some form of runtime data validation
                addRule(rule, byId, byTransactionId)
            })
            break
        case FULFILLED(FETCH_ACTIVE_TRACE_BOOSTS):
            byTransactionId = { ...state.byTransactionId }
            byId = { ...state.byId }
            action.payload.forEach(rule => {
                // @todo add some form of runtime data validation
                addRule(rule, byId, byTransactionId)
            })

            break
        default:
            return state
    }

    return {
        ...state,
        byId,
        byTransactionId,
        loaded: true,
        lastError: false,
    }
}

const addRule = (rule: TracepointRule<DateTime>, byId, byTransactionId) => {
    byId[rule.id] = rule

    if (byTransactionId[rule.transactionId] === undefined) {
        byTransactionId[rule.transactionId] = []
    }

    if (!_.contains(byTransactionId[rule.transactionId], rule.id)) {
        byTransactionId[rule.transactionId].push(rule.id)
    }
}
